import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function LockIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" fill="none" viewBox="0 0 20 20" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15.95 9.12H4.29a1.67 1.67 0 0 0-1.67 1.67v5.83c0 .922.748 1.67 1.67 1.67h11.66a1.67 1.67 0 0 0 1.67-1.67v-5.83a1.67 1.67 0 0 0-1.67-1.67Z"
      />
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M5.96 9.12V5.79c0-2.3 1.86-4.17 4.16-4.17s4.17 1.87 4.17 4.17v3.33"
      />
    </Icon>
  );
}
